/**
 * A worked duration the way the phone shows it: "1h 36m", not "1.6h".
 *
 * The muster printed hours to one decimal place, so 1h 34m, 1h 35m and 1h 36m
 * all read "1.6h", and 4h 59m read "5.0h" — a supervisor comparing the web
 * against the app saw two different answers for the same man on the same day.
 * A decimal hour is also not something anyone reads fluently: 1.6h is 1h 36m,
 * not 1h 60m.
 *
 * Rounds to whole minutes first and splits afterwards, so it can never produce
 * "1h 60m" the way splitting first and rounding the remainder can.
 */
export function formatHours(value) {
  const hours = Number(value);
  if (!Number.isFinite(hours) || hours <= 0) return '0h';
  const minutes = Math.round(hours * 60);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m ? `${h}h ${m}m` : `${h}h`;
}
